/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';

import { type EnderecoPesquisa } from './types';

const pesquisarCepEnderecoEntrega = (cep: string): AxiosPromise<EnderecoPesquisa> => xhr
    .get('/localizacao', { params: { cep } });

export default pesquisarCepEnderecoEntrega;
